<script setup lang="ts">
import { computed } from 'vue'
import type { IProductAttributes } from '@/types/SkuTypes'
import { useI18n } from 'vue-i18n'
import { FormatCurrency } from '@/services/currencyFormatter'
import { useLogger } from 'vue-logger-plugin'
const logger = useLogger()

const props = defineProps<{
  RetailPrice: number | null
  SalePrice: number | null
  IProductAttributes: IProductAttributes | null
  RenderAsTwoLines?: boolean
}>()

logger.info('PricePerUnitWeight props:', props)

const weight = computed(() => props.IProductAttributes?.PricePerUnitWeight ?? null)

const { t } = useI18n()

const unitWeightValue = computed(() => {
  if (weight.value === null || weight.value === undefined) return null
  if (weight.value === 0) return null

  const basePrice = props.SalePrice ?? props.RetailPrice
  if (basePrice === null || basePrice === undefined) return null
  if (basePrice === 0) return null

  const value = (basePrice * 1000) / weight.value
  if (!Number.isFinite(value)) return null

  return Math.round(value * 100) / 100
})

const formattedUnitWeightCurrency = computed(() => {
  if (unitWeightValue.value === null) return null
  if (typeof navigator === 'undefined') return unitWeightValue.value.toFixed(2)
  return FormatCurrency(unitWeightValue.value, null)
})

const wrapperTag = computed(() => (props.RenderAsTwoLines ? 'div' : 'span'))
const lineTag = computed(() => (props.RenderAsTwoLines ? 'div' : 'span'))
</script>

<template>
  <component
    :is="wrapperTag"
    v-if="weight != null && formattedUnitWeightCurrency != null"
  >
    <component :is="lineTag" class="price-per-unit-weight-no-wrap">
      {{ t('labels.PricePerUnitWeight.Weight', [weight]) }}
    </component>
    <component :is="lineTag" class="price-per-unit-weight-no-wrap">
      {{ t('labels.PricePerUnitWeight.PricePerUnit', [formattedUnitWeightCurrency]) }}
    </component>
  </component>
</template>

<style lang="scss">
.price-per-unit-weight-no-wrap {
  white-space: nowrap;
}
</style>
